export default "__VITE_ASSET__Cy6sA1ed__"